import React from 'react';

const MobClose = () => (
  <svg
    overflow="visible"
    width="46px"
    height="46px"
    viewBox="0 0 46 46"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g>
        <circle fill="none" stroke="#FFFFFF" cx="22" cy="22" r="22"></circle>
        <g transform="translate(13.000000, 13.000000)" fill="#FFFFFF">
            <rect transform="translate(9.500000, 9.000000) rotate(-315.000000) translate(-9.500000, -9.000000) " x="9" y="-3" width="1" height="24"></rect>
            <rect transform="translate(9.500000, 9.000000) rotate(-45.000000) translate(-9.500000, -9.000000) " x="9" y="-3" width="1" height="24"></rect>
        </g>
    </g>
  </svg>
)

export default MobClose;



// WEBPACK FOOTER //
// ./src/components/MobClose.js